/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VisionEventModelDto } from '../../models/vision-event-model-dto';

export interface VisionEventsControllerUpdateEvent$Params {
  uuid: string;
  eventUuid: string;
      body: VisionEventModelDto
}

export function visionEventsControllerUpdateEvent(http: HttpClient, rootUrl: string, params: VisionEventsControllerUpdateEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<VisionEventModelDto>> {
  const rb = new RequestBuilder(rootUrl, visionEventsControllerUpdateEvent.PATH, 'put');
  if (params) {
    rb.path('uuid', params.uuid, {});
    rb.path('eventUuid', params.eventUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VisionEventModelDto>;
    })
  );
}

visionEventsControllerUpdateEvent.PATH = '/match-videos/{uuid}/events/{eventUuid}';
